import { commitMutation, graphql } from 'react-relay';

const mutation = graphql`
  mutation GetStravaAccessTokenMutation($input: GetStravaAccessTokenInput!) {
    getStravaAccessToken(input: $input) {
      accessToken
    }
  }
`;

function commit(environment, code, callback) {
  return commitMutation(environment, {
    mutation,
    variables: {
      input: {
        code,
      },
    },
    onCompleted: (response, errors) => {
      if (errors) {
        callback && callback(errors[0]);
      } else {
        callback && callback(null, response.getStravaAccessToken);
      }
    },
    onError: err => {
      callback && callback(err);
    },
  });
}

export default { commit };